import { config as configImport, importModule, require } from "./importModule";
import { controleAcesso, controleAcessoLiberar } from "./controleAcesso";
import Color from "color";
import { Printd } from "printd";
import adapter from "../adapters";
import camposSelecionaveis from "./camposSelecionaveis";
import database from "../database";
import fullCalendarColaboradoresView from "../utils/fullCalendarColaboradoresView";
import historicos from "../utils/petshopHistoricos";
import animais from "../utils/animais";
import { toolbar } from "./toolbar";
import initMenu from "./menu";
import lockSession from "./lockSession";
import mensagens from "./mensagens";
import nfe from "./nfe";
import { sha256 } from "../utils/crypto";
import sharedWorker from "./sharedWorker";
import smart from "./smart";
import toollbarNotify from "./toolbarNotify";
import ufs from "../utils/ufs";
import diff from "../utils/diff";
import roundAbnt from "../utils/roundAbnt";
import itens from "../utils/itens";
import * as documentos from "../utils/documentos";
import initYanda from "./yanda";
import { WsManager } from "./ws";
import colors from "../utils/colors";
import * as bytes from "../utils/bytes";
import visualizarImagem from "../utils/visualizarImagem";
import { proxyRequest } from "./proxyRequest";

export default {
  Color,
  Notify: toollbarNotify,
  controleAcesso,
  controleAcessoLiberar,
  database,

  // load native modules esm
  import: importModule,

  basePath: document.head.dataset.basepath || "",

  start(options, config) {
    Object.assign(this, options);

    // adaptações gerais, yanda, jquery...
    adapter();

    if (options.isSisclaro) {
      Yanda.janela.prototype.setHelp = () => null;
      // não oculta o icone, só não abre a ajuda (barra de titulo e internas)
      Yanda.help = {
        hide: false,
        click: null,
        create: () => null,
        openUrl: () => null,
        createByJanela: () => null,
      };
    }

    this.isSmart = ["snoopySmart", "zettaSmart"].includes(config.modulo);
    this.isSnoopySmart = config.modulo === "snoopySmart";
    this.isZettaSmart = config.modulo === "zettaSmart";
    this.freezeSiggmaKeys();

    // Quando em modo dev a origin padrao fica igual ao server do webpack. Exemplo: http://localhost:8005.
    // Por isso é necessário alterar o base path para os import ESM
    configImport.basePath = this.devMode
      ? `${document.location.origin}${this.basePath}/js/esm`
      : `${this.basePath}/js/esm`;
    configImport.urlArgs = this.urlArgs;
    globalThis.require = require;

    initYanda(this, config.yanda);
    proxyRequest();
    initMenu(config.menu);
    this._worker = sharedWorker();
    this.ws = new WsManager(this._worker.port);
    lockSession(config);
    this.atualizacoes(null);

    this.import("widgets.js").then(({ default: widgets }) => {
      this.$widgets = widgets;
      this.$widgets.init();
      this.startBind(config);
    });

    toolbar(options, config);
    mensagens(config);

    options.zettaManager?.temPermissao &&
      options.zettaManager?.abrirAoIniciar && globalThis.Yanda.newApl(23);

    const [defaultAplId, defaultAplParams] = Array.isArray(config.defaultApl)
      ? config.defaultApl
      : [config.defaultApl, null];
    defaultAplId && globalThis.Yanda.newApl(defaultAplId, defaultAplParams);

    if (globalThis.Siggma.isSmart || config.petshopExibirDashboard) {
      globalThis.Yanda.newApl(22);
    }

    if (globalThis.Siggma.isSmart) {
      if (globalThis.Siggma.usuarioRole !== "suporte") {
        globalThis.Yanda.cmd = () => null;
        const elm = globalThis.document.querySelector("#SystemCmd");
        elm && elm.remove();
      }

      // tela pessoas-novo-full => snoopy smart
      const newApl = globalThis.Yanda.newApl;
      globalThis.Yanda.newApl = function (id, params, dad, callback) {
        if (
          ![19, 46, 48, 51, 240, 611].includes(parseInt(id)) ||
          parseInt(dad?.id || 0) === 66
        ) {
          return newApl(id, params, dad, callback);
        }

        switch (parseInt(id)) {
          case 19:
            params = { id: params, tela: "transportadora" };
            break;
          case 46:
            params = { id: params, tela: "cliente" };
            break;
          case 48:
            params = { id: params, tela: "fornecedor" };
            break;
          case 51:
            params = { id: params, tela: "colaborador" };
            break;
          case 240:
            params.tela = "pessoa";
            break;
          default:
            (!params || (typeof params !== "object")) &&
              (params = { id: params, tela: "pessoa" });
            (dad && dad.id == 69) && (params.tela = "cliente");
            break;
        }

        newApl(611, params, dad, callback);
      };
    }
  },

  freezeSiggmaKeys() {
    globalThis.Siggma.filiais = globalThis.Siggma.filiais.map((f) =>
      Object.freeze(f)
    );
    globalThis.Siggma.allFiliais = globalThis.Siggma.allFiliais.map((f) =>
      Object.freeze(f)
    );
    [
      "id",
      "basePath",
      "decimais",
      "empresa",
      "filiais",
      "allFiliais",
      "filial",
      "filialCnpj",
      "isSmart",
      "isSnoopySmart",
      "isZettaSmart",
      "modulo",
      "usuario",
      "usuarioNome",
      "usuarioRole",
    ].forEach((key) =>
      Object.defineProperty(globalThis.Siggma, key, { writable: false })
    );
  },

  startBind(config) {
    if (!this._worker) {
      return;
    }

    this._worker.port.postMessage({
      cmd: "bind-config",
      data: { url: `${this.basePath}/app/bind`, tempo: 90000 },
    });

    if (config.ws) {
      let origin = config.wsOrigin;
      if (/^:\d+/.test(origin)) {
        origin = `${globalThis.location.origin}${origin}`;
      }
      this._worker.port.postMessage({
        cmd: "ws",
        data: {
          cmd: "start",
          params: {
            url: `${origin}/siggma`,
            empresa: this.empresa,
            usuario: this.usuario,
            basePath: globalThis.Siggma.id || globalThis.Siggma.basePath,
            token: globalThis.document.cookie,
          },
        },
      });
      this._worker.port.postMessage({
        cmd: "ws",
        data: {
          cmd: "on",
          params: "notify",
        },
      });
      this._worker.port.postMessage({
        cmd: "ws",
        data: {
          cmd: "on",
          params: "event",
        },
      });
    }
  },

  registerFullCalendarColaboradores() {
    fullCalendarColaboradoresView();
  },

  getContrastYiq(hexcolor) {
    if (!hexcolor) {
      return "black";
    }
    hexcolor = hexcolor.replace(/^#/, "");
    const r = parseInt(hexcolor.substr(0, 2), 16),
      g = parseInt(hexcolor.substr(2, 2), 16),
      b = parseInt(hexcolor.substr(4, 2), 16),
      yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? "black" : "white";
  },

  showNotify(msg) {
    msg && Notify.success(
      `${msg}<br><br><li>O sistema exibirá/notificará quando for finalizado</li>`,
    );
    setTimeout(() => jQuery("#zt-notify .zt-preview").trigger("click"), 0);
    this._worker && this._worker.port.postMessage({ cmd: "bind" });
  },

  $$(id) {
    const jans = globalThis.Yanda.getJansById(id);
    return jans ? jans[0] : null;
  },

  autocompletePessoa(params) {
    const isPessoa = params.url === "/app/pessoas/find";
    params.url = globalThis.Siggma.basePath + params.url;

    return {
      info:
        "Pesquise por Código, Nome/Razão Social, Apelido/Nome Fantasia, Telefone ou Celular",
      renderItem(ul, data) {
        const pessoa = isPessoa ? data : data.pessoa;
        return jQuery('<li style="display:flex">').append(
          `<div style="flex: 1 auto; overflow: hidden; white-space: nowrap;
            text-overflow: ellipsis; width: 0; line-height: 25px; border-radius: 4px;">
            <b>${data[params.id || "id"]}</b> -
            ${pessoa.cpfcnpj} - ${pessoa.nome.toUpperCase()}
            ${pessoa.apelidoFantasia ? ` - ${pessoa.apelidoFantasia}` : ""}
          </div>`,
        ).appendTo(ul);
      },
      ...params,
    };
  },

  autocompleteItem(params = {}) {
    params.url = globalThis.Siggma.basePath + (params.url || "/app/itens/find");

    return {
      info:
        "Pesquise por Código, Código Original, Código do Fabricante, GTIN ou Descrição",
      renderItem(ul, data) {
        const nome = data.proNom.toUpperCase();
        const valor = parseFloat(data.proValVen || 0)
          .roundNumber(Siggma.decimais);
        let estoqueInfo = "";

        if (params?.estoque) {
          estoqueInfo = `<i class="mdi mdi-cube-scan mdi-18px"></i> ${
            (parseFloat(data.estoque) || 0).roundNumber(Siggma.decimais)
          }`;

          if (data.medSubItem) {
            const estoqueTitle = (parseFloat(~~data.estoque) || 0)
              .roundNumber(Siggma.decimais);
            estoqueInfo =
              `<span title='Estoque: ${estoqueTitle} ${data.medAbr} e
              ${(data.estoque * parseFloat(data.medQtd)).roundNumber(0)}
              ${data.medSubItem}'>
              ${estoqueInfo}
            <span>`;
          }
        }

        return jQuery('<li style="display:flex">').append(
          `<div style="flex: 1 auto; overflow: hidden; white-space: nowrap;
            text-overflow: ellipsis; width: 0; line-height: 25px; border-radius: 4px;"
            title="${nome} - R$ ${valor} - Estoque: ${data.estoque}">
            <b>${data.proCodOri}</b>
            ${data.proCodFab ? ` - ${data.proCodFab}` : ""}
            ${data.proCodOriginal ? ` - ${data.proCodOriginal}` : ""}
            - ${nome} - <b style="color: #43B9D3">R$ ${valor}</b> - ${estoqueInfo}
          </div>`,
        ).appendTo(ul);
      },
      widgetCss: { width: "760px" },
      ...params,
    };
  },

  autocompleteVeiculo(params = {}) {
    params.url = globalThis.Siggma.basePath +
      (params.url || "/cte/veiculos/find");

    return {
      info: "Pesquise por Placa, Descrição, UF",
      renderItem(ul, data) {
        return jQuery('<li style="display:flex">').append(
          `<div style="flex: 1 auto; overflow: hidden; white-space: nowrap;
            text-overflow: ellipsis; width: 0; line-height: 25px; border-radius: 4px;">
            <b>${data.placa}</b> - ${data.nome.toUpperCase()}
            </div>`,
        ).appendTo(ul);
      },
      ...params,
    };
  },

  sendWhatsapp(params = {}) {
    const { pessoa, message = "", suporte = false, phoneSuporte = "" } = params;

    const hdl = Yanda.newJanela({
      btFe: true,
      title: "Complete as informações e continue",
    });

    const msgDefault = message ? `${message}` : "Digite sua mensagem aqui...";
    const tipoWhatsapp = localStorage.getItem("tipo-whatsapp") ?? false;

    hdl.formatPhone = (phone) => {
      const sendPhone = `55${String(phone || "").replace(/\D/g, "")}`;
      return sendPhone.length < 12 ? "" : sendPhone;
    };

    hdl.send = (phone, msg, tipoWhats = false) => {
      const mobile = globalThis.Yanda.util.isMobile()
        ? "api"
        : (tipoWhats ? "api" : "web");

      const sendPhone = hdl.formatPhone(phone);
      if (!sendPhone) {
        return Notify.warning("Número inválido");
      }
      globalThis.open(
        `https://${mobile}.whatsapp.com/send?phone=${sendPhone}&text=${
          encodeURIComponent(msg)
        }`,
      );
    };

    if (suporte) {
      hdl.send(phoneSuporte, msgDefault);
      return;
    }

    const isPetshop = Siggma.isSnoopySmart || Siggma.modulo == 2;
    const height = isPetshop && params.msgAviso ? 165 : 180;
    const divMsgVariaveis = isPetshop && params.msgAviso
      ? `<div style="text-align: center;"><label style="font-weight: bold; color: red;">Para trocar as variáveis na mensagem, selecione um atendimento</label></div>`
      : "";

    hdl.setContent(
      `<div id="container">
        <div id="body">
          <div id="phone" ref="refPhone" style="margin-top: 10px; text-align: center;">
            <s-select2
              style="width: 480px;"
              url="${Siggma.basePath}/app/pessoas/get-phones-by-id?id=${pessoa}"
              v-model="phoneTst"
              field-cod="id"
              field-des="telefone"
              :set-all-values="true"
              tags
              placeholder="Telefone/Celular"
            />
          </div>
          <div id="mensagemPadrao" style="margin-top: 10px">
            <s-select2
              v-model="mensagemPadrao"
              style="width: 480px;"
              url="${Siggma.basePath}/config/mensagens-padroes/find-by-term"
              tela="604"
              tela-search="603"
              field-cod="id"
              field-des="descricao"
              :payload="getTipo"
              placeholder="Mensagem Padrão"
            />
          </div>
          ${divMsgVariaveis}
          <div style="margin-top: 10px">
            <textarea v-model="mensagem" ref="refMsg" style="width: 480px;
              height: ${height}px;">
            </textarea>
          </div>
        </div>
        <div id="footer" style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <div v-if="isZettaWhats">
            <label>
              <input type="checkbox" @click="cbPdf = cbZettaWhats" checked v-model="cbZettaWhats"/>
              Zetta-Whats
            </label>
          </div>
          <s-onoff
            v-if="!isMobile && !cbZettaWhats"
            @change="changeWhatsType"
            :value="whatsType"
            active-text="WhatsApp Desktop"
            inactive-text="WhatsApp Web"
          ></s-onoff>
          <div v-if="cbZettaWhats && exibirEnviarPdf">
            <label>
              <input type="checkbox" v-model="cbPdf"/>
              Enviar PDF
            </label>
          </div>
        </div>
        <div style="display: flex; gap: 8px;">
          <button id="btnCancelar">Cancelar</button>
          <button @click="continuar" class="btn btn-primary">Continuar</button>
        </div>
      </div>
      </div>`,
    );

    hdl.setTamanho(500, 370);
    hdl.centraliza();

    new Vue({
      el: hdl.$("container"),
      data: {
        mensagem: "",
        phoneTst: "",
        mensagemPadrao: "",
        whatsType: false,
        isMobile: false,
        cbPdf: false,
        cbZettaWhats: false,
        isZettaWhats: false,
        exibirEnviarPdf: params.exibirEnviarPdf || false,
      },
      provide: { hdl },

      created() {
        this.consultaZettaWhats();
      },
      mounted() {
        this.mensagem = msgDefault;
        this.whatsType = tipoWhatsapp == "true" ? true : false;
        this.isMobile = globalThis.Yanda.util.isMobile();
      },
      watch: {
        async mensagemPadrao(d) {
          if (!d) {
            this.mensagem = msgDefault;
            return;
          }

          if (!d.mensagem) {
            d.mensagem = await hdl.http(
              `${Siggma.basePath}/config/mensagens-padroes/get-by-id?id=${d.id}`,
            ).then(({ data }) => data.mensagem);
          }

          this.mensagem = d ? `${d.mensagem}` : msgDefault;
          params && (this.mensagem = this.mensagem.replace(
            /\{\{(.*?)\}\}/g,
            (match, grupo) => this.getValor(grupo, match),
          ));
          this.$refs.refMsg.focus();
        },
      },
      methods: {
        changeWhatsType(v) {
          this.whatsType = v;
          localStorage.setItem("tipo-whatsapp", this.whatsType);
        },
        getValor(chave, match) {
          const vars = chave.trim().split(".");
          let result = chave;

          for (let i = 0; i < vars.length; i++) {
            const v = vars[i];
            if (![undefined, null].includes(params[v])) {
              result = params[v];
              continue;
            }
            return match;
          }
          return result;
        },
        async continuar() {
          const sendPhone = hdl.formatPhone(this.phoneTst);
          if (!sendPhone) {
            return Notify.warning("Número inválido");
          }

          if (this.cbZettaWhats) {
            await hdl.http(
              `${Siggma.basePath}/app/zetta-whats/send-document-whats`,
              {
                to: this.phoneTst,
                msg: this.mensagem,
                pedido: params.pedido,
                enviarPdf: this.cbPdf,
              },
            );
          } else if (this.cbPdf) {
            Notify.warning(
              "Somente usuários do ZettaWhats podem enviar arquivos",
            );
          } else {
            hdl.send(this.phoneTst, this.mensagem, this.whatsType);
          }
        },
        getTipo() {
          return { tipo: params.tipoMensagem };
        },
        async consultaZettaWhats() {
          const response = await hdl.http(
            `${Siggma.basePath}/app/zetta-whats/is-active`,
          );
          this.isZettaWhats = response.data;
        },
      },
    });

    hdl.$("btnCancelar").addEventListener("click", () => hdl.close());
    hdl.show();
  },

  /**
   * Abre um modal que envia o report recebido para os números dados.
   * @param {object} data Dados do report.
   * @param {string} arquivo Nome do arquivo.
   * @param {string?} mensagemPadrao Mensagem padrão.
   * @param {string | number?} pessoa O id da pessoa cujo número será preenchido automaticamente ao abrir.
   */
  sendReportWhatsapp(data, arquivo, mensagemPadrao = "", pessoa) {
    const hdl = Yanda.newJanela({
      btFe: true,
      title: "Complete as informações e continue",
    });

    hdl.send = (numeros, mensagem) => {
      if (numeros.length === 0) {
        Notify.warning("Informe um número");
        return;
      }

      data.arquivo = arquivo;
      data.numeros = JSON.stringify(numeros);
      data.mensagem = mensagem;
      hdl.http(
        `${Siggma.basePath}/app/report/enviar-whatsapp`,
        data,
      );
    };

    hdl.setContent(
      `<div id="container">
        <div id="body">
          <div id="phone" ref="refPhone" style="margin-top: 10px; text-align: center;">
            <s-select2
              style="width: 480px;"
              url="${Siggma.basePath}/app/pessoas/get-phones-by-term"
              v-model="phones"
              field-cod="id"
              field-des="telefone"
              multiple
              tags
              placeholder="Telefone/Celular"
            />
          </div>
          <div style="margin-top: 10px">
            <textarea v-model="mensagem" ref="refMsg" style="width: 480px; height: 180px;">
            </textarea>
          </div>
        </div>
        <div id="footer">
            <button @click="continuar" id="btnContinuar" style="float: right;" class="btn btn-primary">Continuar</button>
            <button id="btnCancelar" style="float: right; margin-right: 4px">Cancelar</button>
        </div>
      </div>`,
    );

    hdl.setTamanho(500, 320);
    hdl.centraliza();

    new Vue({
      el: hdl.$("container"),
      data: {
        mensagem: "",
        phones: [],
      },
      provide: { hdl },
      async mounted() {
        this.mensagem = mensagemPadrao || "Digite sua mensagem aqui...";
        if (!pessoa) {
          return;
        }
        const { results } = await hdl.http(
          `${Siggma.basePath}/app/pessoas/get-phones-by-id?id=${pessoa}`,
        );
        const avisoNumeroInvalido =
          "Cliente não possui um número telefone/celular válido. Preencha manualmente";
        if (!results) {
          Notify.warning(avisoNumeroInvalido);
          return;
        }

        results.forEach(
          (o) => {
            const num = `55${o.id.replace(/\D/g, "")}`;
            if (num.length >= 12) {
              this.phones.push(o.id);
            }
          },
        );
        if (this.phones.length === 0) {
          Notify.warning(avisoNumeroInvalido);
        }
      },
      methods: {
        continuar() {
          const numeros = this.phones.map((o) => `55${o.replace(/\D/g, "")}`);
          if (numeros.some((o) => o.length < 12)) {
            Notify.warning("Um dos números informados possui tamanho inválido");
            return;
          }
          hdl.send(numeros, this.mensagem);
        },
      },
    });

    hdl.$("btnCancelar").addEventListener("click", () => hdl.close());
    hdl.show();
  },

  gerarPdf(hdl, data) {
    (typeof data === "object")
      ? (data.modulo = Siggma.modulo)
      : (data += `&modulo=${Siggma.modulo}`);

    const Yanda = globalThis.Yanda;
    hdl.http({
      url: `${Siggma.basePath}/app/report/gerar-pdf`,
      callback: true,
      data,
    }).then((xhr) => {
      const resp = JSON.parse(xhr.responseText);
      if (resp.type !== "success") {
        Yanda.message(resp);
        return;
      }
      resp.data
        ? Yanda.newApl(104, { url: resp.data })
        : Siggma.showNotify(resp.msg);
    }).catch(() => null);
  },

  gerarXls(hdl, data, name = "report") {
    const body = Object.entries(data)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join("&");

    hdl.setCarregando(true);

    globalThis.fetch(`${Siggma.basePath}/app/report/gerar-xls`, {
      method: "post",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      }),
      body,
    })
      .then((resp) => resp.blob())
      .then((blob) => {
        const url = globalThis.URL || globalThis.webkitURL;

        const link = globalThis.document.createElement("a");
        link.setAttribute("href", url.createObjectURL(blob));
        link.setAttribute("download", `${name}.xls`);
        link.click();
      })
      .catch(async (blob) => {
        const isJson = blob?.type === "application/json";
        const resp = (isJson ? JSON.parse(await blob?.text()) : null) || {
          type: "warning",
          msg: "Houve um erro ao gerar o relatório",
          detail: [
            "Verifique os parametros e tente novamente.",
            "Caso o erro persistir entre em contato com o suporte técnico.",
          ].join("<br>"),
        };

        globalThis.Yanda.message(resp);
      })
      .finally(() => hdl.setCarregando(false));
  },

  gerarXlsAsync(hdl, data) {
    hdl.http({
      url: `${Siggma.basePath}/app/report/gerar-xls-async`,
      callback: true,
      data,
    }).then((xhr) => {
      const resp = JSON.parse(xhr.responseText);
      (resp.type !== "success")
        ? globalThis.Yanda.message(resp)
        : globalThis.Siggma.showNotify(resp.msg);
    }).catch(() => null);
  },

  atualizacoes(data) {
    const $elm = jQuery("#zt-atualizacoes");
    if (!data) {
      $elm.hide();
      return;
    }

    const msg = !data.atualizar
      ? `<b>-</b> ${data.inicio} <b>à</b> ${data.termino}`
      : `<b>-</b> ${data.atualizar} <b>entre</b> ${data.inicio} <b>às</b> ${data.termino}`;

    $elm.find(".zt-detail-value").html(msg);
    $elm.find("p").html(data.mensagem);

    $elm.show();
  },

  atualizarAgenda() {
    const ref = Siggma.$$(422);
    ref && ref.atualizarAgenda && ref.atualizarAgenda();
  },

  async setUsuariosPreferencias(data) {
    return await fetch(
      `${Siggma.basePath}/app/index/set-usuarios-preferencias`,
      {
        method: "post",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        }),
        body: new URLSearchParams(data),
      },
    )
      .then((resp) => resp.json())
      .then((resp) => (resp.type !== "success" ? Promise.reject(resp) : resp));
  },

  async getUsuariosPreferencias(data) {
    return await fetch(
      `${Siggma.basePath}/app/index/get-usuarios-preferencias?data=${
        JSON.stringify(data)
      }`,
    )
      .then((resp) => resp.json())
      .then((resp) => (resp.type !== "success" ? Promise.reject(resp) : resp));
  },

  async getFiliaisPreferencias(data) {
    return await fetch(
      `${Siggma.basePath}/app/index/get-filiais-preferencias?data=${
        JSON.stringify(data)
      }`,
    )
      .then((resp) => resp.json())
      .then((resp) => (resp.type !== "success" ? Promise.reject(resp) : resp));
  },

  async setFiliaisPreferencias(data) {
    return await fetch(
      `${Siggma.basePath}/app/index/set-filiais-preferencias`,
      {
        method: "post",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        }),
        body: new URLSearchParams(data),
      },
    )
      .then((resp) => resp.json())
      .then((resp) => (resp.type !== "success" ? Promise.reject(resp) : resp));
  },

  async getPreferencias(data) {
    return await fetch(
      `${Siggma.basePath}/app/index/get-preferencias?data=${
        JSON.stringify(data)
      }`,
    )
      .then((resp) => resp.json())
      .then((resp) => (resp.type !== "success" ? Promise.reject(resp) : resp));
  },

  async setPreferencias(data) {
    return await fetch(`${Siggma.basePath}/app/index/set-preferencias`, {
      method: "post",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      }),
      body: new URLSearchParams(data),
    })
      .then((resp) => resp.json())
      .then((resp) => (resp.type !== "success" ? Promise.reject(resp) : resp));
  },

  async checkPermission(chave) {
    const resp = await fetch(
      `${Siggma.basePath}/app/auth/check-permission?chave=${chave}`,
    ).then((resp) => resp.json());

    return resp.type !== "success";
  },

  async getFinalizarPagamentos() {
    return Siggma.isSnoopySmart || await Siggma
      .getFiliaisPreferencias(["finalizarPagamentos"])
      .then(({ data }) => data.finalizarPagamentos === "true")
      .catch(() => false);
  },

  async getFinalizarPagamentosEntradas() {
    return await Siggma
      .getFiliaisPreferencias(["finalizarPagamentosEntradas"])
      .then(({ data }) => data.finalizarPagamentosEntradas === "true")
      .catch(() => false);
  },

  addGoogleMapsApi() {
    if (typeof google !== "undefined" && google.maps) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyBN3Pzyy18aBvzbmBJeIYe8-knPo6yoI5o&language=pt-br";
      script.id = "maps-googleapis-com";
      script.addEventListener("load", () => resolve(), { once: true });
      document.head.appendChild(script);
    });
  },

  addGoogleChartsApi() {
    if (typeof google !== "undefined" && google.charts) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://www.gstatic.com/charts/loader.js";
      script.id = "gstatic-charts";
      script.addEventListener("load", () => {
        try {
          // Versão 'current' está ocasionando conflito entre o webfont.js e o require.js
          google.charts.load("46", {
            packages: ["corechart", "table", "bar"],
            language: "pt-br",
          });
          google.charts.setOnLoadCallback(resolve);
        } catch (_e) {
          reject("Não foi possível carregar api GoogleCharts");
        }
      }, { once: true });
      document.head.appendChild(script);
    });
  },

  openManager() {
    fetch(`${Siggma.basePath}/config/usuarios/get-manager-url`)
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.type != "success") {
          Yanda.message(resp);
          return;
        }
        const url = resp?.data;
        globalThis.open(url, "_blank");
      })
      .catch(() => {
        Yanda.message({
          type: "warning",
          msg: "Erro ao fazer requisição do Token de acesso",
        });
      });
  },

  async waitForJob(id, options = { timeout: 300000, signal: null }) {
    const startAt = new Date().getTime();
    let aborted = false;
    while (!aborted) {
      const { data: job } = await fetch(
        `${Siggma.basePath}/app/index/wait-for-job?id=${id}`,
        { signal: options.signal },
      )
        .then((resp) => resp.json());
      if (job) {
        return job;
      }
      if (options.signal.aborted) {
        aborted = true;
      }
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (new Date().getTime() - startAt > options.timeout) {
        aborted = true;
      }
    }
    return null;
  },

  utils: {
    diff,
    colors,
    roundAbnt,
    documentos,
    bytes,
    camposSelecionaveis,
    async fillSelect2ByIds(ids, url, elm) {
      ids?.length &&
        await fetch(`${Siggma.basePath}${url}`, {
          method: "POST",
          body: new URLSearchParams({ ids }),
        })
          .then((resp) => resp.json())
          .then((resp) => {
            const $elm = jQuery(elm);
            $elm.html("");
            (resp.results || []).forEach((r) =>
              $elm.append(new Option(r.text, r.id))
            );
            $elm.val(ids).trigger("change.select2");
          })
          .catch(() => null);
    },
    distanciaEntreDoisPontos(latitude1, longitude1, latitude2, longitude2) {
      const raioTerra = 6371; // raio da Terra em km
      const lat1Rad = parseFloat(latitude1) * (Math.PI / 180);
      const lat2Rad = parseFloat(latitude2) * (Math.PI / 180);
      const deltaLatRad = (parseFloat(latitude2) - parseFloat(latitude1)) *
        (Math.PI / 180);
      const deltaLonRad = (parseFloat(longitude2) - parseFloat(longitude1)) *
        (Math.PI / 180);

      const haversineFormula = (
        Math.sin(deltaLatRad / 2) * Math.sin(deltaLatRad / 2)
      ) +
        (
          Math.cos(lat1Rad) * Math.cos(lat2Rad) *
          Math.sin(deltaLonRad / 2) *
          Math.sin(deltaLonRad / 2)
        );
      const anguloCentral = 2 * Math.atan2(
        Math.sqrt(haversineFormula),
        Math.sqrt(1 - haversineFormula),
      );

      const distancia = raioTerra * anguloCentral;

      return parseFloat(distancia.toFixed(10));
    },
    grid: {
      loadOptions(gridOptions) {
        const str = typeof gridOptions === "string"
          ? gridOptions
          : JSON.stringify(gridOptions);
        return eval("(" + str.replaceAll('"#', "").replaceAll('#"', "") + ")");
      },
      async getOptions(id, extra = {}) {
        return await fetch(
          `${Siggma.basePath}/app/tela-consulta/get-grid-options?id=${id}`,
        )
          .then((resp) => resp.json())
          .then((resp) => this.loadOptions(Object.assign(resp.data, extra)));
      },
    },
    isNumeroNacional(phone) {
      const prefixos = [
        "0300",
        "0500",
        "0800",
        "0900",
        "3003",
        "4000",
        "4001",
        "4002",
        "4003",
        "4004",
        "4005",
        "4007",
        "4020",
        "4021",
        "4022",
      ];

      return prefixos.some((prefixo) => phone.startsWith(prefixo));
    },
    /**
     * Printd - Biblioteca para impressão de documentos.
     * Documentação: https://github.com/joseluisq/printd#readme
     */
    Printd,
    visualizarImagem,
  },

  crypto: {
    sha256,
  },

  // TODO: Mover as chaves abaixo para dentro de info
  smart,
  petshop: {
    historicos,
  },
  nfe,

  info: {
    itens: { tipos: itens.getTipos() },
    petshop: { animais },
    ufs: ufs.getAll(),
  },
};
